import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    root: {
      borderRadius: "8px",
      background: theme.white00,
      width: "100%",
      "& th:not('.MuiTableCell-alignLeft')": { flexDirection: "row-reverse" },
      "& th": {
        background: `${theme.gray50} !important`,
        padding: theme.spacing(7, 8),
        fontWeight: 400,
        borderRight: `1px solid ${theme.gray100}`,
        borderLeft: 0,
        position: "static",
        lineHeight: "16px",
      },

      flex: ({ fullView }: { fullView?: boolean }) => (fullView ? "1" : 0),
      "& td ": {
        padding: `${theme.spacing(4, 8)} !important`,
        borderRight: `1px solid ${theme.gray100}`,
        borderLeft: 0,
      },
    },
    Table: {
      borderCollapse: "separate",
      "& tr": { background: theme.white00 },

      "& th,td": {
        height: "50px",
      },
    },
    TooltipInTable: {
      color: theme.gray400,
      height: theme.spacing(10),
      opacity: "0.5",
      width: theme.spacing(10),
      marginRight: theme.spacing(5),
    },
    visuallyHidden: {
      border: 0,
      clip: "rect(0 0 0 0)",
      height: 1,
      margin: -1,
      overflow: "hidden",
      padding: 0,
      position: "absolute",
      top: theme.spacing(10),
      width: 1,
    },
    MoreIcon: {
      color: theme.gray400,
      cursor: "pointer",
      fontSize: 24,
      verticalAlign: "middle",
    },
    actionCell: {
      textAlign: "center",
      whiteSpace: "nowrap",
      width: "1%",
      right: 0,
      zIndex: 4,
      overflow: "hidden",
      background: "inherit",
      borderLeft: `1px solid ${theme.gray100} !important`,
      borderBottom: "1px solid rgba(224, 224, 224, 1)",
      fontWeight: 400,
    },
    tableCell: {
      color: theme.gray800,
      fontWeight: 700,
      whiteSpace: "nowrap",
      "& svg": {
        color: `${theme.gray500} !important`,
        verticalAlign: "middle",
      },
    },
    tableCellWithMinWidth: {
      minWidth: "250px",
    },
    skeletonTableCell: {
      whiteSpace: "nowrap",
    },
    caption: {
      lineHeight: "49px!important" as any,
      textAlign: "center!important" as any,
      padding: "0!important" as any,
    },
    pagination: {
      "& .MuiTablePagination-actions": {
        "[dir='rtl'] &": {
          display: "flex",
          flexDirection: "row-reverse",
          transform: "rotate(180deg)",
        },
      },
    },
    fullView: {
      maxHeight: "100%",
      margin: theme.spacing(0, -12),
      borderRadius: "0 !important",
      borderLeft: "0 !important",
      borderRight: "0 !important",
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
    },
    checkbox: {
      padding: 0,
      marginRight: theme.spacing(4),
      "& svg": {
        color: "unset !important",
      },
    },
    noResultsFilter: {
      width: "100%",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    infoWrapper: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    iconWrapper: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "50%",
      backgroundColor: theme.primary50,
      width: "44px",
      height: "44px",
      marginBottom: theme.spacing(12),
    },
    filterIcon: {
      color: theme.primary500,
    },
    noResultsTitle: {
      marginBottom: theme.spacing(4),
      color: theme.primary800,
      fontSIze: 24,
      fontWeight: 500,
    },
    noResultsDesc: {
      marginBottom: theme.spacing(12),
      color: theme.gray500,
      fontSize: 16,
      fontWeight: 400,
    },
    buttonIcon: {
      width: 16,
      height: 16,
    },
  }),
);
